import axios from "axios";
import { Partner_Service_URL } from "./../Url";

export const PartnerSidebarActions = {
  GET_PARTNER_SIDEBAR_REQUEST: "GET_PARTNER_SIDEBAR_REQUEST",
  GET_PARTNER_SIDEBAR_SUCCESS: "GET_PARTNER_SIDEBAR_SUCCESS",
  GET_PARTNER_SIDEBAR_ERROR: "GET_PARTNER_SIDEBAR_ERROR",
  GET_PARTNER_SIDEBAR_LOADING: "GET_PARTNER_SIDEBAR_LOADING",
};

export const getPartnerSidebar = (props) => async (dispatch, getState) => {
  const accessToken = props.accessToken ?? getState()?.auth?.idToken;

  const { partnerFirmId } = props;
  dispatch(getpartnerSidebarLoading());
  return axios({
    method: "post",
    url: `${Partner_Service_URL}/getPartnerDetails`,
    headers: {
      authorization: "Bearer " + accessToken,
    },
    params: {
      partnerFirmId,
    },
  })
    .then((response) => {
      if (response.status >= 200 && response.status < 300) {
        dispatch(getpartnerSidebarSuccess(response.data));
        return response;
      } else if (response.status === 401) {
        return response;
      } else {
        const error = new Error(response.statusText);
        dispatch(getpartnerSidebarError(error));
        throw error;
      }
    })
    .catch((error) => {
      dispatch(getpartnerSidebarError(error));
      throw error;
    });
};

export function getpartnerSidebarError(error) {
  return {
    type: PartnerSidebarActions.GET_PARTNER_SIDEBAR_ERROR,
    payload: error,
  };
}

export function getpartnerSidebarSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: PartnerSidebarActions.GET_PARTNER_SIDEBAR_SUCCESS,
      payload: props,
    });
  };
}

export function getpartnerSidebarLoading() {
  return {
    type: PartnerSidebarActions.GET_PARTNER_SIDEBAR_LOADING,
  };
}
